import IMask from "imask"

export default function (el, { expression }, { Alpine, evaluate }) {
    Alpine.bind(el, {
        'x-init'() {
            const options = evaluate(expression)
            IMask(el, options)
        },
    })
}